/* bf-cart.js — BF mobile redesign (2026-09). Stream file; gate every behaviour on BF.isMobile(). Loaded deferred after bf-core.js. */
/* B5 owns: the bag drawer's re-render from the Section Rendering API on every bf:cart:updated, the stepper /
   remove delegation inside the drawer, and the "Added to Your Bag" title mode after an ATC. Opening the drawer
   after an ATC is bf-product.js's job (it owns the 320 ms step). Cart-page behaviour is B6 — this file only ever
   acts on nodes inside [data-bf-sheet="bag"]. */
(function () {
  "use strict";
  if (!window.BF) return;
  var BF = window.BF;
  var SECTION_ID = 'bf-cart-drawer';
  var inFlight = false;

  function drawerEl() { return document.querySelector('[data-bf-sheet="bag"]'); }

  /* Dawn interop (CONTRACTS §5): keep CartItems and any Dawn subscriber in sync. Bare globals from pubsub.js/constants.js. */
  function dawnPublish(detail) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bf', cartData: detail && detail.cart });
      }
    } catch (e) { /* noop */ }
  }

  /* Title follows data-bf-drawer-mode ('bag' → "Your Bag (n)" · 'added' → "Added to Your Bag"). */
  function applyMode(root) {
    root = root || drawerEl();
    if (!root) return;
    var t = root.querySelector('[data-bf-drawer-title]');
    if (!t) return;
    var mode = root.getAttribute('data-bf-drawer-mode') || 'bag';
    var next = mode === 'added' ? t.getAttribute('data-bf-title-added') : t.getAttribute('data-bf-title-bag');
    if (next) t.textContent = next;
  }

  /* Swap the drawer's innerHTML from a freshly rendered section, keeping is-open / hidden / mode on the live root. */
  function swapFrom(fresh) {
    var live = drawerEl();
    if (!live || !fresh) return false;
    live.innerHTML = fresh.innerHTML;
    var n = fresh.getAttribute('data-bf-cart-count');
    if (n !== null) live.setAttribute('data-bf-cart-count', n);
    applyMode(live);
    return true;
  }

  function refresh(detail) {
    var html = detail && detail.sections && detail.sections[SECTION_ID];
    if (html) return Promise.resolve(swapFrom(BF.parseHTML(html).querySelector('[data-bf-sheet="bag"]')));
    return BF.renderSection(window.location.pathname, SECTION_ID)
      .then(function (root) { return swapFrom(root.querySelector('[data-bf-sheet="bag"]')); })
      .catch(function () { return false; });
  }

  /* ---- re-render on every mutation. 'load' is the server-rendered state core replays on boot — no fetch. ---- */
  BF.on('bf:cart:updated', function (e) {
    var d = e.detail || {};
    if (d.source === 'load') return;
    var root = drawerEl();
    if (root && d.source === 'atc') root.setAttribute('data-bf-drawer-mode', 'added');
    refresh(d);
  });

  /* ---- the "Added" title is a one-shot: the next open is the ordinary bag again ---- */
  BF.on('bf:drawer:close', function () {
    var root = drawerEl();
    if (!root) return;
    root.setAttribute('data-bf-drawer-mode', 'bag');
    applyMode(root);
  });

  /* ---- stepper / remove inside the drawer; one request at a time, row optimistically disabled ---- */
  document.addEventListener('click', function (e) {
    if (!BF.isMobile()) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-bf-action]');
    if (!btn) return;
    if (!btn.closest('[data-bf-sheet="bag"]')) return; /* the cart page is B6's surface */
    var action = btn.getAttribute('data-bf-action');
    if (action !== 'minus' && action !== 'plus' && action !== 'remove') return;
    e.preventDefault();
    if (inFlight || btn.disabled) return;

    var row = btn.closest('.bf-line');
    if (!row) return;
    var index = parseInt(row.getAttribute('data-bf-line-index'), 10);
    if (!index) return;
    var qtyEl = row.querySelector('[data-bf-qty]');
    var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
    var next = action === 'remove' ? 0 : (action === 'plus' ? qty + 1 : qty - 1);
    if (next < 0) return;
    if (action === 'minus' && qty <= 1) return;

    inFlight = true;
    row.classList.add('is-busy');
    BF.cart.change({ line: index, quantity: next }, [SECTION_ID, 'cart-icon-bubble'], 'drawer')
      .then(function (detail) { dawnPublish(detail); })
      .catch(function () { row.classList.remove('is-busy'); })
      .then(function () { inFlight = false; });
  });

  /* ---- the server-rendered drawer already matches the cart on load; just settle the title ---- */
  BF.ready(function () { applyMode(); });
})();

/* ==================================================================================================
   B6 — cart page (/cart). Owns everything inside `.bf-cart` and the "…" actions sheet
   [data-bf-sheet="actions"]; the B5 block above deliberately ignores [data-bf-action] outside
   [data-bf-sheet="bag"], so the two surfaces never fight over a click.
   D4-prototype-map §7 · CONTRACTS §5 (events + Dawn publish), §6 (line hooks), §8 (BF.cart.*).
   ================================================================================================== */
(function () {
  "use strict";
  if (!window.BF) return;
  var BF = window.BF;
  var SHEET = 'actions';
  var busy = false;          /* one cart request at a time (Cloudflare discipline) */
  var actionIndex = 0;       /* line index the actions sheet was opened for */
  var pendingDiscount = null;/* { code } while a /cart/update.js {discount} is in flight */
  var discountUi = null;     /* { open, value, error } forced onto the next render */

  function cartEl() { return document.querySelector('.bf-cart'); }
  function onCartPage() { return !!cartEl(); }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }

  /* The cart section's Section Rendering id is NOT the literal 'cart-items' on this store.
     templates/cart.json is a JSON template, so Shopify prefixes the template key with the template id:
     the live DOM id is `shopify-section-template--23208130117851__cart-items` and
     `/cart?section_id=cart-items` answers 404 (measured 2026-09-07, verify/B-B6/self/diag.json).
     Read it from the DOM, exactly as CONTRACTS §6 already prescribes for the collection grid, so the
     code survives a template-id change. `cart-icon-bubble` and `bf-cart-drawer` ARE static sections
     and keep their literal ids. */
  function sectionId() {
    var el = cartEl();
    var host = el && el.closest ? el.closest('.shopify-section') : null;
    if (host && host.id) return host.id.replace('shopify-section-', '');
    var any = document.querySelector('main .shopify-section[id$="__cart-items"], #shopify-section-cart-items');
    return any ? any.id.replace('shopify-section-', '') : 'cart-items';
  }
  function pageSections() { return [sectionId(), 'cart-icon-bubble', 'bf-cart-drawer']; }

  /* Dawn interop (CONTRACTS §5) — same helper as the drawer block, kept local to stay side-effect free. */
  function publishToDawn(detail) {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bf', cartData: detail && detail.cart });
      }
    } catch (e) { /* noop */ }
  }

  /* ---------------- discount state helpers ---------------- */
  function discountRoot(root) { return (root || document).querySelector('[data-bf-discount]'); }

  function errorText(root) {
    var d = discountRoot(root);
    return (d && d.getAttribute('data-bf-discount-error-text')) || "That code isn't valid.";
  }

  function readDiscountUi(root) {
    var d = discountRoot(root);
    if (!d) return null;
    var form = d.querySelector('[data-bf-discount-form]');
    var input = d.querySelector('[data-bf-discount-input]');
    var err = d.querySelector('[data-bf-discount-error]');
    return {
      open: !!(form && !form.hidden),
      value: input ? input.value : '',
      error: err && !err.hidden ? err.textContent : ''
    };
  }

  function writeDiscountUi(root, state) {
    var d = discountRoot(root);
    if (!d || !state) return;
    var toggle = d.querySelector('[data-bf-action="discount-open"]');
    var form = d.querySelector('[data-bf-discount-form]');
    var input = d.querySelector('[data-bf-discount-input]');
    var err = d.querySelector('[data-bf-discount-error]');
    if (form) form.hidden = !state.open;
    if (toggle) { toggle.hidden = !!state.open; toggle.setAttribute('aria-expanded', state.open ? 'true' : 'false'); }
    if (input) input.value = state.value || '';
    if (err) { err.textContent = state.error || ''; err.hidden = !state.error; }
  }

  /* Success test, in the order the brief gives: the cart's own discount_codes verdict first, then a
     cart-level application carrying the code, then a line-level allocation, then "total_discount grew". */
  function discountApplied(cart, code) {
    if (!cart || !code) return false;
    var want = String(code).trim().toUpperCase();
    var i, j, list, alloc, app;
    list = cart.discount_codes;
    if (list && list.length) {
      for (i = 0; i < list.length; i++) {
        if (list[i] && String(list[i].code || '').toUpperCase() === want) return list[i].applicable === true;
      }
    }
    list = cart.cart_level_discount_applications || [];
    for (i = 0; i < list.length; i++) {
      if (String(list[i].title || list[i].key || '').toUpperCase() === want) return true;
    }
    list = cart.items || [];
    for (i = 0; i < list.length; i++) {
      alloc = list[i].line_level_discount_allocations || [];
      for (j = 0; j < alloc.length; j++) {
        app = alloc[j].discount_application || {};
        if (String(app.title || app.key || '').toUpperCase() === want) return true;
      }
    }
    return (cart.total_discount || 0) > 0;
  }

  /* ---------------- re-render ---------------- */
  function swapCart(fresh) {
    var live = cartEl();
    if (!live || !fresh) return false;
    var keep = discountUi || readDiscountUi(live);
    live.innerHTML = fresh.innerHTML;
    discountUi = null;
    writeDiscountUi(live, keep);
    return true;
  }

  function renderCart(detail) {
    var id = sectionId();
    var html = detail && detail.sections && detail.sections[id];
    if (html) {
      var swapped = swapCart(BF.parseHTML(html).querySelector('.bf-cart'));
      if (swapped) return Promise.resolve(true);
    }
    return BF.renderSection(cartUrl(), id)
      .then(function (root) { return swapCart(root.querySelector('.bf-cart')); })
      .catch(function (err) {
        if (window.console) console.warn('[BF] cart re-render failed for section', id, err);
        return false;
      });
  }

  BF.on('bf:cart:updated', function (e) {
    var d = e.detail || {};
    if (d.source === 'load' || !onCartPage()) return;
    if (pendingDiscount) {
      var code = pendingDiscount.code;
      pendingDiscount = null;
      discountUi = discountApplied(d.cart, code)
        ? { open: false, value: '', error: '' }
        : { open: true, value: code, error: errorText() };
      /* paint the verdict on the live DOM straight away; swapCart re-applies it after the swap, so the
         message is correct whether or not the Section Rendering round-trip succeeds */
      writeDiscountUi(cartEl(), discountUi);
    }
    renderCart(d);
  });

  /* ---------------- mutations ---------------- */
  function mutate(promise, row) {
    busy = true;
    if (row) row.classList.add('is-busy');
    return promise
      .then(function (detail) { publishToDawn(detail); return detail; })
      .catch(function (err) { if (row) row.classList.remove('is-busy'); throw err; })
      .then(function (v) { busy = false; return v; }, function (err) { busy = false; throw err; });
  }

  function changeLine(index, quantity, row) {
    return mutate(BF.cart.change({ line: index, quantity: quantity }, pageSections(), 'cart-page'), row);
  }

  function applyDiscount(code) {
    var d = discountRoot();
    var apply = d && d.querySelector('[data-bf-action="discount-apply"]');
    if (apply) apply.disabled = true;
    pendingDiscount = { code: code };
    return mutate(BF.cart.update({ discount: code }, pageSections(), 'cart-page'), null)
      .catch(function (err) {
        pendingDiscount = null;
        var live = cartEl();
        writeDiscountUi(live, { open: true, value: code, error: (err && err.body && err.body.description) || errorText(live) });
        if (apply) apply.disabled = false;
        if (window.console) console.warn('[BF] discount apply failed', err && err.status);
      });
  }

  /* ---------------- delegation ---------------- */
  document.addEventListener('click', function (e) {
    if (!BF.isMobile() || !onCartPage()) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('[data-bf-action]');
    if (!btn) return;
    var inCart = !!btn.closest('.bf-cart');
    var inSheet = !!btn.closest('[data-bf-sheet="' + SHEET + '"]');
    if (!inCart && !inSheet) return;              /* the drawer is B5's, handled above */
    var action = btn.getAttribute('data-bf-action');
    var row = btn.closest('.bf-line');

    if (action === 'more') {
      e.preventDefault();
      actionIndex = parseInt(row && row.getAttribute('data-bf-line-index'), 10) || 0;
      BF.openSheet(SHEET, { opener: btn });
      return;
    }

    if (action === 'minus' || action === 'plus') {
      e.preventDefault();
      if (busy || btn.disabled || !row) return;
      var index = parseInt(row.getAttribute('data-bf-line-index'), 10);
      if (!index) return;
      var qtyEl = row.querySelector('[data-bf-qty]');
      var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10) || 1;
      if (action === 'minus' && qty <= 1) return;
      changeLine(index, action === 'plus' ? qty + 1 : qty - 1, row).catch(function () { /* noop */ });
      return;
    }

    if (action === 'remove') {
      e.preventDefault();
      if (busy) return;
      var target = inSheet ? actionIndex : parseInt(row && row.getAttribute('data-bf-line-index'), 10);
      if (!target) return;
      if (inSheet) { BF.closeSheet(SHEET); actionIndex = 0; }
      changeLine(target, 0, inSheet ? null : row).catch(function () { /* noop */ });
      return;
    }

    if (action === 'discount-open') {
      e.preventDefault();
      var live = cartEl();
      writeDiscountUi(live, { open: true, value: (readDiscountUi(live) || {}).value || '', error: '' });
      var input = live && live.querySelector('[data-bf-discount-input]');
      if (input) { try { input.focus({ preventScroll: true }); } catch (err2) { input.focus(); } }
      return;
    }

    if (action === 'discount-apply') {
      e.preventDefault();
      if (busy) return;
      var field = cartEl() && cartEl().querySelector('[data-bf-discount-input]');
      var code = field ? field.value.trim() : '';
      if (!code) { if (field) field.focus(); return; }
      applyDiscount(code);
      return;
    }

    if (action === 'discount-clear') {
      e.preventDefault();
      if (busy) return;
      discountUi = { open: false, value: '', error: '' };
      mutate(BF.cart.update({ discount: '' }, pageSections(), 'cart-page'), null).catch(function () { /* noop */ });
    }
  });

  /* Enter inside the discount field applies the code (the field is not inside a <form>). */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !BF.isMobile() || !onCartPage()) return;
    var input = e.target;
    if (!input || !input.hasAttribute || !input.hasAttribute('data-bf-discount-input')) return;
    e.preventDefault();
    if (busy) return;
    var code = input.value.trim();
    if (code) applyDiscount(code);
  });
})();
